<template>
    <div class="divider"></div>
</template>

<script>
export default {
    name: 'Divider',
}
</script>

<style scoped>

.divider {
    height: 1px;
    background-color: var(--color-gray);
}
</style>